import React from 'react'
import {nanoid} from "nanoid"

export default [
    {
        id: nanoid(),
        Title: "Web Development",
        isHeld: false,
        skills: ["HTML - Advanced", "CSS - Advanced", "React - Advanced", "Java Script - Intermediate", "PHP - Intermediate"]
    },
    {
        id: nanoid(),
        Title: "Programming Languages",
        isHeld: false,
        skills: ["Python - Intermediate", "Java - Intermediate", "SQL - Intermediate", "MIPS - Intermediate"]

    },
    {
        id: nanoid(),
        Title: "Technological",
        isHeld: false,
        skills: ["Microsoft Office", " Photoshop", "Fast and Accurate Typing"]

    },
    {
        id: nanoid(),
        Title: "Languages",
        isHeld: false,
        skills: ["English - Fluent", "Romanian - Fluent", "German - Learning"]
    },
    {
        id: nanoid(),
        Title: "Interpersonal",
        isHeld: false,
        skills: ["Team Working", "Communication", "Flexible"]
    },
    {
        id: nanoid(),
        Title: "Other",
        isHeld: false,
        skills: ["Organisational", "Problem Solving", "Resilient"]
    },
]
